var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBurger = function SvgBurger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3h16v1.615H2V3ZM2 8.845h16v1.615H2V8.845ZM2 14.418h16v1.615H2v-1.615Z",
    fill: "#25241D"
  })));
};

export { SvgBurger as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuOTk5OTQgM0gxOFY0LjYxNTA3SDEuOTk5OTRWM1oiIGZpbGw9IiMyNTI0MUQiLz4KPHBhdGggZD0iTTEuOTk5OTQgOC44NDUyMUgxOFYxMC40NjAzSDEuOTk5OTRWOC44NDUyMVoiIGZpbGw9IiMyNTI0MUQiLz4KPHBhdGggZD0iTTEuOTk5OTQgMTQuNDE4MkgxOFYxNi4wMzMzSDEuOTk5OTRWMTQuNDE4MloiIGZpbGw9IiMyNTI0MUQiLz4KPC9zdmc+Cg==";